import {axios as http} from "@/plugins/http"

export default class Api {
    static statistic() {
        return http.get("/api/v1/promocodes/coupon/statistic").then((resp) => {
            return resp.data.data
        }).catch(() => {
            return {
                coupon_not_parsed: 0,
            }
        });
    }
}
